import { ButtonV2 } from '@cimplico/components';
import { useRefreshXeroEntity } from '../../../../queries/use-refresh-xero-entity';
import { toastNotification } from '../../../../components/toast/Toast';
import { ExclamationTriangleIcon } from '@heroicons/react/24/solid';

type XeroEntityRefreshProps = {
    entityId: string;
    onXeroError: (error?: { name: string; message: string }) => void;
};

function XeroEntityRefresh({ entityId, onXeroError }: XeroEntityRefreshProps): JSX.Element {
    const refreshXeroEntityQuery = useRefreshXeroEntity(entityId);

    function handleRefresh(): void {
        refreshXeroEntityQuery.mutate(
            { entityId },
            {
                onSuccess: () => {
                    toastNotification('success', 'Xero entity refreshed!');
                },
                onError: (res) => {
                    const error = res.response?.data.error;
                    const message = res.response?.data.message;

                    if (error && message) {
                        onXeroError({ message, name: error });
                    }

                    toastNotification('error', 'Unable to refresh Xero entity!', message);
                },
            }
        );
    }

    return (
        <div className="mt-4 flex flex-col gap-2">
            <div>
                <ButtonV2
                    type="secondary"
                    label={refreshXeroEntityQuery.isLoading ? 'Refreshing...' : 'Refresh Details'}
                    size="sm"
                    onClick={handleRefresh}
                    isLoading={refreshXeroEntityQuery.isLoading}
                    isDisabled={refreshXeroEntityQuery.isLoading}
                />
            </div>
            <div className="flex gap-2 items-center max-w-[350px]">
                <ExclamationTriangleIcon className="h-4 w-4 text-yellow-500 shrink-0" />
                <p className="text-gray-600 text-xs">
                    Changing the type of an entity may affect procedures and certification for open workpapers.
                </p>
            </div>
        </div>
    );
}
export default XeroEntityRefresh;
